import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { WebUIThemeProvider } from 'web-ui-components/lib/utilities/themes';

import envConfigPropTypes from '../../../states/envConfig/propTypes';
import {
	goToPaymentsPage,
	goToDebitLandingPage,
	goToCreditLandingPage,
	goToDebitPaymentsPage,
} from '../../../states/page/actions';
import { initialiseBacsCredit } from '../../../states/bacsCredit/actions';
import LayoutContainer from '../LayoutContainer/LayoutContainer';
import { paymentPropType } from '../../../states/bacsCredit/proptypes';
import { TYPE_BACS_CREDIT, TYPE_BACS_DEBIT } from '../../../config';

import { initialiseBacsDebit } from '../../../states/bacsDebit/actions';
import { updateTemplateName, goToBacsTemplate } from '../../../states/templates/actions';
import withContent from '../../../containers/withContent';
import bacsCreditReviewContent from '../BacsReview/CreditReviewPage/CreditReview.content';

const mapDispatch = (dispatch) => ({
	initialiseBacsCredit: (bacsDetails, payments) => dispatch(initialiseBacsCredit(bacsDetails, payments)),
	initialiseBacsDebit: (bacsDetails, payments) => dispatch(initialiseBacsDebit(bacsDetails, payments)),
	goToCreditPaymentsPage: () => dispatch(goToPaymentsPage()),
	goToCreditLandingPage: () => dispatch(goToCreditLandingPage()),
	goToDebitPaymentsPage: () => dispatch(goToDebitPaymentsPage()),
	goToDebitLandingPage: () => dispatch(goToDebitLandingPage()),
	updateTemplateName: (templateName) => dispatch(updateTemplateName(templateName)),
	goToBacsTemplate: (paymentType) => dispatch(goToBacsTemplate(paymentType)),
});

class App extends Component {
	constructor(props) {
		super(props);

		const {
			initialiseBacsCredit,
			initialiseBacsDebit,
			goToDebitPaymentsPage,
			goToCreditPaymentsPage,
			paymentDetails: { bacsDetails } = {},
			payments,
			paymentType,
			templateName,
			updateTemplateName,
			goToBacsTemplate,
		} = props;

		if (payments && payments.length > 0 && bacsDetails) {
			if (paymentType === TYPE_BACS_CREDIT) {
				initialiseBacsCredit(bacsDetails, payments);
				if (templateName) {
					updateTemplateName(templateName);
					goToBacsTemplate(TYPE_BACS_CREDIT);
				} else {
					goToCreditPaymentsPage();
				}
			} else if (paymentType === TYPE_BACS_DEBIT) {
				initialiseBacsDebit(bacsDetails, payments);
				if (templateName) {
					updateTemplateName(templateName);
					goToBacsTemplate(TYPE_BACS_DEBIT);
				} else {
					goToDebitPaymentsPage();
				}
			}
		}
	}

	componentDidUpdate(prevProps) {
		const { goToCreditLandingPage, goToDebitLandingPage, paymentType } = this.props;

		if (!isEqual(paymentType, prevProps.paymentType)) {
			if (paymentType === TYPE_BACS_CREDIT) {
				goToCreditLandingPage();
			} else {
				goToDebitLandingPage();
			}
		}
	}

	render() {
		const {
			copCheckTriggered,
			handleRoute,
			handleBack,
			handleSelectPaymentType,
			handleDisplayFullwidth,
			handleAddPayee,
			resetPaymentList,
			handlePaymentInReview,
			envConfig,
			isBootStrapInProgress,
			content: { content },
			sessionCOPChecks,
		} = this.props;

		return (
			<WebUIThemeProvider brandID={envConfig.brandId}>
				<LayoutContainer
					copCheckTriggered={copCheckTriggered}
					handleRoute={handleRoute}
					handleBackParent={handleBack}
					resetPaymentList={resetPaymentList}
					handleSelectPaymentType={handleSelectPaymentType}
					handleDisplayFullwidth={handleDisplayFullwidth}
					handleAddPayee={handleAddPayee}
					handlePaymentInReview={handlePaymentInReview}
					isBootStrapInProgress={isBootStrapInProgress}
					content={content}
					sessionCOPChecks={sessionCOPChecks}
				/>
			</WebUIThemeProvider>
		);
	}
}

App.propTypes = {
	user: PropTypes.shape({ id: PropTypes.string }),
	handleBack: PropTypes.func,
	handleRoute: PropTypes.func.isRequired,
	handleSelectPaymentType: PropTypes.func,
	handleDisplayFullwidth: PropTypes.func,
	handlePaymentInReview: PropTypes.func,
	handleAddPayee: PropTypes.func,
	resetPaymentList: PropTypes.func,
	paymentDetails: PropTypes.shape({
		bacsDetails: PropTypes.shape({
			id: PropTypes.string,
			settlementDate: PropTypes.string,
			submissionDate: PropTypes.string,
			paymentName: PropTypes.string,
			bacsId: PropTypes.string,
		}),
	}),
	payments: PropTypes.arrayOf(PropTypes.shape(paymentPropType)),
	initialiseBacsCredit: PropTypes.func.isRequired,
	initialiseBacsDebit: PropTypes.func.isRequired,
	goToDebitPaymentsPage: PropTypes.func.isRequired,
	goToCreditPaymentsPage: PropTypes.func.isRequired,
	goToCreditLandingPage: PropTypes.func.isRequired,
	goToDebitLandingPage: PropTypes.func.isRequired,
	paymentType: PropTypes.string.isRequired,
	envConfig: PropTypes.shape(envConfigPropTypes).isRequired,
	updateTemplateName: PropTypes.func.isRequired,
	goToBacsTemplate: PropTypes.func.isRequired,
	templateName: PropTypes.string,
	isBootStrapInProgress: PropTypes.bool.isRequired,
	copCheckTriggered: PropTypes.func,
	sessionCOPChecks: PropTypes.object,
};
const contentWrapper = withContent({ content: bacsCreditReviewContent });
export default compose(connect(null, mapDispatch), contentWrapper)(App);
